/* Salerita — scroll infinito nas filas de produtos da página inicial (secções .pp, ex.: "Saldos de Outono").
   Mesmo princípio do prompt do Kiko: carrega só o lote seguinte quando a cliente se aproxima do fim,
   um pedido de cada vez, sem duplicados, e pára quando a coleção acaba. */
(function () {
  'use strict';
  if (window.SalPPInfinite) return;
  window.SalPPInfinite = true;
  var BATCH = 10;

  var css = '' +
    '.pp--inf .pp__grid{display:flex!important;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;gap:14px}' +
    '.pp--inf .pp__grid::-webkit-scrollbar{display:none}' +
    '.pp--inf .pp__card{display:block!important;flex:0 0 calc((100% - 56px) / 5);scroll-snap-align:start}' +
    '.pp--inf .pp__wrap{position:relative}' +
    '.pp--inf .pp__arrow{position:absolute;top:38%;transform:translateY(-50%);z-index:3;width:44px;height:44px;border-radius:50%;border:1px solid #ddd;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.08)}' +
    '.pp--inf .pp__arrow[disabled]{opacity:0;pointer-events:none}' +
    '.pp--inf .pp__arrow--prev{left:-8px}.pp--inf .pp__arrow--next{right:-8px}' +
    '.pp--inf .pp__arrow svg{width:14px;height:14px}' +
    '.pp--inf .pp__end{flex:0 0 1px}' +
    '@media (max-width:749px){.pp--inf .pp__card{flex:0 0 64%}.pp--inf .pp__arrow{display:none}.pp--inf .pp__grid{gap:12px}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function money(cents) {
    var v = (Number(cents) || 0).toFixed(2).replace('.', ',');
    return '€' + v;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function card(p, handle) {
    var price = null, compare = null;
    (p.variants || []).forEach(function (v) {
      var pr = parseFloat(v.price);
      if (price === null || pr < price) { price = pr; compare = v.compare_at_price ? parseFloat(v.compare_at_price) : null; }
    });
    var pct = compare && compare > price ? Math.round((compare - price) * 100 / compare) : 0;
    var img = p.images && p.images[0] ? p.images[0].src : '';
    var a = document.createElement('a');
    a.className = 'pp__card';
    a.href = '/collections/' + handle + '/products/' + p.handle;
    a.setAttribute('data-pp-handle', p.handle);
    a.innerHTML =
      '<div class="pp__media">' +
        (pct > 0 ? '<span class="pp__badge">-' + pct + '%</span>' : '') +
        (img ? '<img loading="lazy" decoding="async" alt="' + esc(p.title) + '" src="' + imgUrl(img, 720) + '" srcset="' +
          [360, 540, 720, 900].map(function (w) { return imgUrl(img, w) + ' ' + w + 'w'; }).join(', ') +
          '" sizes="(max-width: 749px) 64vw, 20vw">' : '') +
      '</div>' +
      '<p class="pp__name">' + esc(p.title) + '</p>' +
      '<div class="pp__prices">' +
        (pct > 0 ? '<span class="pp__compare">' + money(compare) + '</span><span class="pp__sale">' + money(price) + '</span>'
                 : '<span>' + money(price) + '</span>') +
      '</div>';
    return a;
  }

  function setup(section) {
    var grid = section.querySelector('.pp__grid');
    var all = section.querySelector('.pp__all');
    if (!grid || !all) return;
    var m = (all.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    section.classList.add('pp--inf');

    var seen = new Set();
    grid.querySelectorAll('.pp__card').forEach(function (c) {
      var h = (c.getAttribute('href') || '').split('/products/')[1];
      if (h) seen.add(h.split(/[?#]/)[0]);
    });
    var loaded = grid.querySelectorAll('.pp__card').length;
    var nextPage = Math.floor(loaded / BATCH) + 1;
    var busy = false, done = loaded < BATCH;

    // setas (desktop)
    var wrap = document.createElement('div');
    wrap.className = 'pp__wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);
    var arrow = '<svg viewBox="0 0 284.49 498.98" aria-hidden="true"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg>';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'pp__arrow pp__arrow--prev'; prev.setAttribute('aria-label', 'Anterior');
    prev.innerHTML = arrow.replace('<svg', '<svg style="transform:scaleX(-1)"');
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'pp__arrow pp__arrow--next'; next.setAttribute('aria-label', 'Seguinte');
    next.innerHTML = arrow;
    wrap.appendChild(prev); wrap.appendChild(next);
    function step() { var c = grid.querySelector('.pp__card'); return c ? (c.getBoundingClientRect().width + 14) * 2 : 300; }
    prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    function arrows() {
      prev.disabled = grid.scrollLeft < 5;
      next.disabled = done && grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 5;
    }
    grid.addEventListener('scroll', arrows, { passive: true });

    var sentinel = document.createElement('span');
    sentinel.className = 'pp__end';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.appendChild(sentinel);

    function load() {
      if (busy || done) return;
      busy = true;
      fetch('/collections/' + handle + '/products.json?limit=' + BATCH + '&page=' + nextPage, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          var ps = (data && data.products) || [];
          var frag = document.createDocumentFragment();
          ps.forEach(function (p) {
            if (!p || !p.handle || seen.has(p.handle)) return;
            seen.add(p.handle);
            frag.appendChild(card(p, handle));
          });
          grid.insertBefore(frag, sentinel);
          nextPage++;
          if (ps.length < BATCH) { done = true; io.disconnect(); sentinel.remove(); }
          busy = false;
          arrows();
        })
        .catch(function (e) { console.warn('[SalPPInfinite]', e); busy = false; });
    }

    var io = new IntersectionObserver(function (en) {
      if (en[0] && en[0].isIntersecting) load();
    }, { root: grid, rootMargin: '0px 900px 0px 0px' });
    if (!done) io.observe(sentinel); else sentinel.remove();
    arrows();
  }

  function start() { document.querySelectorAll('section.pp').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
